import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import { useCIMSNotificationsPanelContext } from 'components/CIMSNotifications/components/CIMSNotificationsPanelContext'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import DisciplineFormItem from './DisciplineFormItem'
import CIMSSection from 'components/CIMSSection'
const Help = HelpMessage.DesignSubmittals.Notifications

const RenderFormItems: React.FC = () => {
  const { event } = useCIMSNotificationsPanelContext()
  return (
    <>
      <CIMSSection
        title={`Every ${event.name} Event`}
        help={HelpMessage.Notifications.Every(event, 'Design Submittal')}
      >
        <CIMSFormItem label="Recipients" name="recipients">
          <RecipientsSelect />
        </CIMSFormItem>
      </CIMSSection>
      <CIMSSection title="Discipline" help={Help.ByDiscipline(event)}>
        <CIMSFormItem name="dsDiscipline">
          <DisciplineFormItem />
        </CIMSFormItem>
      </CIMSSection>
    </>
  )
}

export default RenderFormItems
